module.exports = __webpack_public_path__ + "static/media/meme_5.5ad85413.jpg";